import React, { ChangeEvent, Component, useState } from "react";
import "./ConvertQuoteToOrderModal.scss";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import OwButton from "../../shared/OwButton/OwButton";
import OwInputWrapper from "../../shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwTitle from "../../shared/OwTitle/OwTitle";
import { Socket } from "socket.io-client";

type Props = {
    closeModalFn: () => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    submitFn: (options: { poNo?: string }) => void;
};

export const ConvertQuoteToOrderModal: React.FC<Props> = (props) => {
    const [poNo, setPoNo] = useState("");

    const closeModal = () => {
        props.closeModalFn();
    };

    const handleChange = (e: ChangeEvent<any>) => {
        const name = e.target.name;
        const value = e.target.value;

        if (name === "po_no") {
            setPoNo(value);
        }
    };

    const submit = () => {
        props.submitFn({ poNo });
    };

    const isSubmitDisabled = () => {
        let isDisabled = false;

        if (props.supplierModel.require_po_on_convert_quote) {
            if (!poNo.length) {
                isDisabled = true;
            }
        }

        return isDisabled;
    };

    return (
        <div className={"ConvertQuoteToOrderModal p-2"}>
            <div className={"w-100"}>
                <div className={"d-flex justify-content-between"}>
                    <OwTitle leftIconName={"fad fa-exchange"} title={"convert_quote_to_order"} tag={"h3"} />
                    <div>
                        <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={closeModal} />
                    </div>
                </div>
            </div>

            <div>
                <div>
                    <OwLabel title={"po_no"} showIsReqAsterik={props.supplierModel.require_po_on_convert_quote} />
                    <div>
                        <OwInputWrapper name={"po_no"} value={poNo} fn={handleChange} />
                    </div>
                </div>

                <div className={"mt-3"}>
                    <OwButton title={"submit"} fn={submit} disabled={isSubmitDisabled()} />
                </div>
            </div>
        </div>
    );
};
